const APP_SHELL_CACHE = 'emg-app-shell-v1';

export async function requestPersistentStorage(): Promise<boolean> {
  if (typeof navigator === 'undefined' || !navigator.storage?.persist) {
    return false;
  }

  try {
    const alreadyPersisted = await navigator.storage.persisted();
    if (alreadyPersisted) {
      return true;
    }
    return navigator.storage.persist();
  } catch {
    return false;
  }
}

/** Re-touch app shell cache on launch (helps iOS eviction). */
export async function reCacheAppShell(): Promise<void> {
  if (typeof caches === 'undefined') {
    return;
  }

  try {
    const cache = await caches.open(APP_SHELL_CACHE);
    const shellUrls = ['/', '/index.html'];

    for (const url of shellUrls) {
      try {
        const response = await fetch(url, { cache: 'reload' });
        if (response.ok) {
          await cache.put(url, response);
        }
      } catch {
        // SW precache may already cover this route
      }
    }
  } catch {
    // Non-fatal: Workbox precache is the primary offline layer
  }
}

export function registerOnlineListeners(onChange: (online: boolean) => void): () => void {
  if (typeof window === 'undefined') {
    return () => undefined;
  }

  const handleOnline = () => onChange(true);
  const handleOffline = () => onChange(false);

  window.addEventListener('online', handleOnline);
  window.addEventListener('offline', handleOffline);

  return () => {
    window.removeEventListener('online', handleOnline);
    window.removeEventListener('offline', handleOffline);
  };
}

export function getInitialOnlineStatus(): boolean {
  return typeof navigator !== 'undefined' ? navigator.onLine : true;
}
